import { render, staticRenderFns } from "./Formpop.vue?vue&type=template&id=039a625e&scoped=true&"
import script from "./Formpop.vue?vue&type=script&lang=js&"
export * from "./Formpop.vue?vue&type=script&lang=js&"
import style0 from "./Formpop.vue?vue&type=style&index=0&id=039a625e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a625e",
  null
  
)

export default component.exports